<template lang="pug">
    div
        loading-dialog(:loading="loadingData")
        crud-form(
            v-show="!loadingData"
            :fields="fields"
            noButtons
            )
            branch-offices-list( :items="listItems" @success="refresh()" noEdit slot="appendContent" )
</template>

<script>
import { CrudForm, LoadingDialog } from '@/components/reusable_components/'
import CustomerDetailFields from './fields/CustomerDetailFields.js'
import CustomerService from '@/services/api/customer'
import { removeRUTHyphen } from '@/services/RUTFormatter'
import { BranchOfficesList } from '@/components/lists'
export default {
    name: 'customer-detail',
    props: {},
    data: function() {
        return {
            fields: CustomerDetailFields,
            listItems: [],
            loadingData: false,
        }
    },
    computed: {},
    methods: {
        async fillForm() {
            this.getCustomerData()
        },
        /**
         *
         */
        async getCustomerData() {
            this.setLoadingDataSpinner(true)
            //
            let customer = await CustomerService.findById(this.getCustomerId())
            let fields = [...this.fields]

            fields[0].value = removeRUTHyphen(customer.rut)
            fields[1].value = customer.alias_name
            fields[2].value = customer.business_name
            fields[3].value = customer.core_business
            this.fields = [...fields]
            
            this.listItems = customer.branch_offices
            console.log(customer.branch_offices)
            this.listItems = [...this.listItems]
            //
            this.setLoadingDataSpinner(false)
        },
        /**
         *
         */
        getCustomerId() {
            return this.$route.params.id
        },
        /**
         *
         */
        setLoadingDataSpinner(value){
            this.loadingData =  value
        }
    },
    watch: {},
    components: {
        'crud-form': CrudForm,
        'branch-offices-list': BranchOfficesList,
        'loading-dialog': LoadingDialog,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: async function() {
        await this.fillForm()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>